export const testimonialsData = [
  {
    quote: "SolveDot Labs' AI chatbot transformed our customer service. We've seen a 40% reduction in response times and a huge spike in customer satisfaction.",
    author: "Aditi",
    company: "YSL Traders"
  },
  {
    quote: "The IoT smart home system is flawless. The reliability and zero downtime promise is not just a claim—it's a reality. Our clients are thrilled.",
    author: "Bhushan",
    company: "Brainyhand Automation."
  },
  {
    quote: "The custom CRM they built for us is intuitive, powerful, and has had 100% uptime since launch. It's the backbone of our sales team now.",
    author: "Lalit",
    company: "YSL Traders"
  }
];
